package com.ives.modules.tags;

import js.html.Element;

import haxe.xml.Fast;

import com.er453r.hxcompo.Component;

import com.ives.utils.Remoting;
import com.ives.components.popup.Popup;
import com.ives.utils.Log;

class Tags extends Module{
	static public inline var TAGS_MODULE:String = "TAGS_MODULE";

	private static var stripTags = ~/(<([^>]+)>)/ig;

	private var divs:Array<Element>;

	public function new() {
		workspaceModule = false;

		on(closeButton, "click", close);
		on(filter, "input", onFilter);
	}

	private function onFilter(){
		Log.debug('Filtering tags by ${filter.value}');

		for(row in divs){
			var content:String = stripTags.replace(row.innerHTML, "");

			if(content.toLowerCase().indexOf(filter.value.toLowerCase()) != -1)
				row.style.display = "table-row";
			else
				row.style.display = "none";
		}
	}

	override public function handleModuleEvent(event:ModuleEvent){
		if(event.type == TAGS_MODULE){
			new Popup(this).open("#viewer");

			filter.value = "";

			Remoting.getXML(dicomViewer.originalDicomImageData.sourceName, dicomViewer.originalDicomImageData.id, onXmlData);
		}
	}

	private function onXmlData(string:String){
		Log.debug('Received XML');

		var tagsXML:Fast = new Fast(Xml.parse(string).firstElement());

		clear();
		divs = [];

		for(child in tagsXML.elements){
			var component:Component = addNode(child);

			append(component);
			divs.push(component.viewElement);
		}
	}

	private function addNode(xml:Fast):Component{
		var tag = "-";

		if(xml.has.keyword)
			tag = xml.att.keyword;

		var value:String = "-";
		var extendedValue:String;

		if(xml.nodes.Value.length == 1)
			value = xml.node.Value.innerHTML;
		else if(xml.innerHTML.length > 0)
			value = StringTools.htmlEscape(xml.innerHTML);

		var ae:String = "-";

		if(xml.has.tag)
			ae = '(${xml.att.tag},';

		if(xml.has.vr)
			ae += '${xml.att.vr})';
		else
			ae = "-)";

		return new TagsRow(tag, value, ae);
	}

	private function close(){
		dispatch(Popup.CLOSE);
	}
}
